var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{attrs:{"id":"tabNav"}},_vm._l((_vm.NavList),function(item,index){return _c('section',{key:index,class:{ active: _vm.activeNavIndex === index },on:{"click":function($event){return _vm.clickTab(index, item.name)}}},[_c('van-icon',{attrs:{"name":item.icon}}),_c('div',[_vm._v(_vm._s(item.title))])],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }